import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ButtonComponent} from "../../components/ui/button/button.component";
import {CardComponent} from "../../components/ui/card/card.component";
import {DetailEntryFieldComponent} from "../../components/ui/detail-entry-field/detail-entry-field.component";
import {InputComponent} from "../../components/ui/input/input.component";
import {TableComponent} from "../../components/ui/table/table.component";
import {TranslateModule} from "@ngx-translate/core";
import {MapComponent} from "../../components/ui/map/map.component";
import {firstValueFrom, map, Subscription, timeout, timer} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {AsyncPipe, DatePipe, NgIf} from "@angular/common";
import {PointCloudService} from "../../services/point-cloud.service";
import {PointCloud} from "../../models/point-cloud";

@Component({
  selector: 'app-point-cloud-detail-info',
  standalone: true,
  imports: [
    ButtonComponent,
    CardComponent,
    DetailEntryFieldComponent,
    TranslateModule,
    MapComponent,
    AsyncPipe,
    DatePipe,
    NgIf
  ],
  templateUrl: './point-cloud-detail-info.component.html',
  styleUrl: './point-cloud-detail-info.component.scss'
})
export class PointCloudDetailInfoComponent implements AfterViewInit, OnDestroy {
  pointCloud$ = this.route.parent!.data.pipe(map(data => data['pointCloud'] as PointCloud));
  downloading = false;
  converting = false;
  downloadingTagsShapefile = false;
  @ViewChild('map') map?: MapComponent;
  subscriptions: Subscription[] = [];

  constructor(private route: ActivatedRoute, private pointCloudService: PointCloudService) {
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.pointCloud$
        .subscribe(pointCloud => {
          if (this.map && pointCloud) {
            const line = pointCloud.locationPoints.map(point => ({ lat: point.latitude, lng: point.longitude }));

            this.map.createPolyline('polyline', line);
          }
        })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  async download() {
    try {
      this.downloading = true;
      const pointCloud = await firstValueFrom(this.pointCloud$);
      const blob = await firstValueFrom(this.pointCloudService.download(pointCloud));

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `point-cloud-${pointCloud.id}.ply`;

      a.click();
      window.URL.revokeObjectURL(url);

      this.downloading = false;
    } catch (e) {
      console.error(e);
    }
  }

  async convert() {
    if (this.converting) {
      return;
    }

    this.converting = true;

    try {
      const pointCloud = await firstValueFrom(this.pointCloud$);
      const blob = await firstValueFrom(this.pointCloudService.convertLas(pointCloud));

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `point-cloud-${pointCloud.id}.las`;

      a.click();
      window.URL.revokeObjectURL(url);

      this.converting = false;
    } catch (e) {
      console.error(e);
    }
  }

  async downloadTagsShapefile() {
    if (this.downloadingTagsShapefile) {
      return;
    }

    this.downloadingTagsShapefile = true;

    try {
      const pointCloud = await firstValueFrom(this.pointCloud$);
      const blob = await firstValueFrom(this.pointCloudService.tagsShapefile(pointCloud));

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `point-cloud-${pointCloud.id}.zip`;

      a.click();
      window.URL.revokeObjectURL(url);

      this.downloadingTagsShapefile = false;
    } catch (e) {
      console.error(e);
    }
  }

  getStatusClass(status?: PointCloud['status']): string {
    switch (status) {
      case 'CREATED':
        return 'text-blue-600';
      case 'IN_PROGRESS':
        return 'text-yellow-600';
      case 'FINISHED':
        return 'text-green-600';
      default:
        return '';
    }
  }
}
